module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetMedium.a5acde4.jpg";